export default __webpack_public_path__ + "static/media/checkList.6d00bdd6.svg";